import { Alert, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import Button from 'components/Button'
import FontAwesome from 'react-fontawesome'
import Input from './Input'

const Buttons = styled.div`
  padding-top: 6px;
  button {
    margin-right: 10px;
  }
`

const Form = ({
  footprints,
  expanded,
  handleSubmit,
  handleChange,
  formFields,
  formChanged,
  resetForm
}) => {
  const colSize = expanded ? 6 : 12
  return (
    <form onSubmit={handleSubmit}>
      <Input value={footprints.id} icon="paw" readOnly />
      <Row>
        {formFields.name && (
          <Col xs={colSize}>
            <Input
              value={formFields.name}
              icon="user-o"
              placeholder="Name"
              handleChange={handleChange}
              name="name"
            />
          </Col>
        )}
        {formFields.lastname && (
          <Col xs={colSize}>
            <Input
              value={formFields.lastname}
              icon="user"
              placeholder="Last Name"
              handleChange={handleChange}
              name="lastname"
            />
          </Col>
        )}
        {formFields.email && (
          <Col xs={colSize}>
            <Input
              value={formFields.email}
              icon="envelope-o"
              placeholder="Email"
              handleChange={handleChange}
              name="email"
            />
          </Col>
        )}
        {formFields.phone && (
          <Col xs={colSize}>
            <Input
              value={formFields.phone}
              icon="phone"
              placeholder="Phone"
              handleChange={handleChange}
              name="phone"
            />
          </Col>
        )}
      </Row>

      {formChanged() && (
        <Buttons>
          <Button primary disabled={footprints.isUpdating}>
            {!footprints.isUpdating && 'Save'}
            {footprints.isUpdating && <FontAwesome name="spinner" spin />}
          </Button>
          {!footprints.isUpdating && <Button onClick={resetForm}>Reset</Button>}
        </Buttons>
      )}
      {footprints.message && (
        <Alert bsStyle="success">{footprints.message}</Alert>
      )}
    </form>
  )
}

export default Form
